/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#imgSRDC[_ngcontent-%COMP%]{width:50%;margin-left:25%;margin-top:10%;margin-bottom:2%}#loginForm[_ngcontent-%COMP%]{width:50%;margin-left:25%}#loginButton[_ngcontent-%COMP%]{width:100%;margin-top:1%}.ui.form-group[_ngcontent-%COMP%]{margin:1% 0}#forgotPassword[_ngcontent-%COMP%]{width:25%;margin-top:1%}\n/*# sourceMappingURL=login.component.css.map*/"];
export { styles as styles };
